var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-map-wrapper"},[_c('div',{ref:"map",staticClass:"simple-map"})])
}
var staticRenderFns = []

export { render, staticRenderFns }